<i [attr.data-feather]="icon" class="icon-eye"></i>
